module.exports = __webpack_public_path__ + "img/resolve the scarlet mist incident.351b8fb9.png";